import React from 'react';
import Countdown from 'react-countdown';
import styled from 'styled-components';

const CountdownWithoutType = Countdown as any; // required as not typed by default

interface Props {
  date: string;
}

/**
 * Countdown component which counts down in seconds to the specified unix date string
 */
const TimeCountdown: React.FC<Props> = ({ date }) => {
  const dateObject = new Date(date);
  const renderCountdown = ({ formatted: { days, hours, minutes, seconds }, completed }) => {
    const counterComponents: (string | number)[] = [];

    const splitDigits = (count: number, seperator = true) => {
      const countString = String(count);
      for (let i = 0; i < countString.length; i++) {
        counterComponents.push(Number(countString.charAt(i)));
      }
      if (seperator) counterComponents.push(':');
    };

    if (days !== '00') splitDigits(days);
    splitDigits(hours);
    splitDigits(minutes);
    splitDigits(seconds, false);

    return (
      <CountdownContainer>
        {counterComponents.map((item: string | number, index: number) => (
          <span key={index} className={`countdown-digit countdown-digit-${typeof item}`}>
            {item}
          </span>
        ))}
      </CountdownContainer>
    );
  };

  return <CountdownWithoutType date={dateObject} renderer={renderCountdown} zeroPadTime={2} />;
};

export default TimeCountdown;

const CountdownContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0;
  gap: 3px;
`;
